module.exports = __webpack_public_path__ + "static/img/icon_lease.4b6f1d5a.png";